import * as C from '../../../i18n/constants';
import { registerCondition, getCondition } from '../conditionRegisterer';
import { CONDITION_NAME as CONDITION_EQUAL } from './equal';
export var CONDITION_NAME = 'neq';
export function condition(dataRow, inputValues) {
  return !getCondition(CONDITION_EQUAL, inputValues)(dataRow);
}
registerCondition(CONDITION_NAME, condition, {
  name: C.FILTERS_CONDITIONS_NOT_EQUAL,
  inputsCount: 1,
  showOperators: true
});


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/es/plugins/filters/condition/notEqual.js
// module id = /SKw
// module chunks = 0